import StaffManagementTableFilter from "./staff-management-table-filter";
import StaffAttendanceTableFilter from "./staff-attendance-table-filter";
import StaffAuditLogTableFilter from "./staff-audit-log-table-filter";
import StaffCheckInHistoryTableFilter from "./staff-check-in-history-table-filter";


const StaffManagementFilters = {
    Table: StaffManagementTableFilter,
    AttendanceTable: StaffAttendanceTableFilter,
    AuditLogTable: StaffAuditLogTableFilter,
    CheckInHistoryTable: StaffCheckInHistoryTableFilter,
};

export default StaffManagementFilters;
